import $ from 'jquery'
window.jQuery = window.$ = $

jQuery.noConflict()

import Header from './modules/w-header'
import Footer from './modules/w-footer'
import BgParallax from './modules/w-bg-parallax'
import ProgramsSlider from './modules/w-programs-mob-slider'
import CustomParallaxWrapper from './modules/custom-parallax/w-custom-parallax-wrapper'
import HeroCarousel from './modules/w-hero-carousel'
import InViewport from './global/w-inViewport'
import ContactBtn from './modules/w-contact-btn'
import ExpandedTip from './modules/w-expanded-tip'
import HeaderSearch from './modules/w-header-search'
import HeaderScroll from './modules/w-header-scroll'
import HeaderDevices from './modules/w-header-devices'
import StickyText from './modules/w-sticky-text'
import UserCarousel from './modules/w-user-carousel'
// import LogoShrinked from './modules/w-logo-shrinked';
import StickyTabs from './modules/w-sticky-tabs'
import OverlapStrips from './modules/w-overlap-strips'
import ReadMore from './modules/w-disclaimer-read-more'
import Tabs from './modules/w-tabs'
import InfoTabs from './modules/w-info-tabs'
import Lottie from './modules/w-lottie'
import TableSlider from './modules/w-table-cards-swiper'

import Faqs from './modules/w-faqs'
import ShowMore from './modules/w-download-show-more'
import Gallery from './modules/w-gallery'
//  import CollapseTable from './modules/w-collapse-net-price-table';
import Video from './modules/w-video'
import NetPriceSlider from './modules/w-net-price-slider'
import Map from './modules/w-map'
import StepSlider from './modules/w-step-mob-slider'
import PhotoTextSlider from './modules/w-photo-text-slider'

window.onYouTubeIframeAPIReady = () => {
  document.dispatchEvent(new Event('on-youtube-iframe-api-ready'))
}

document.onreadystatechange = () => {
  if (document.readyState === 'complete') {
    // document is ready. Do your stuff here

    new Header(document.querySelector('.header'))
    new Footer(document.querySelector('.footer'))

    document.querySelectorAll('.s-bg-parallax').forEach((i) => {
      new BgParallax(i)
    })

    document.querySelectorAll('.s-programs__items').forEach((i) => {
      new ProgramsSlider(i)
    })

    document.querySelectorAll('.s-custom-parallax').forEach((i) => {
      new CustomParallaxWrapper({ element: i, countFrames: 4 })
    })

    new HeroCarousel(document.querySelector('.s-hero-carousel'))

    new ContactBtn(document.querySelector('.b-contactBtn'))

    document.querySelectorAll('.inViewport').forEach((i) => {
      new InViewport({
        element: i,
        threshold: 170,
        cls: 'onScreen',
        trigger: function () {},
      })
    })

    document.querySelectorAll('.b-tip--expanded').forEach((i) => {
      new ExpandedTip(i)
    })

    new HeaderSearch(document.querySelector('.header__search'))
    new HeaderScroll(document.querySelector('.header'))
    new HeaderDevices(document.querySelector('.header'))

    document
      .querySelectorAll('.s-sticky-text .s-sticky-text__row')
      .forEach((i) => {
        new StickyText(i)
      })

    document.querySelectorAll('.s-user-carousel__items').forEach((i) => {
      new UserCarousel(i)
    })

    document.querySelectorAll('.s-mutual-funds__tabs').forEach((i) => {
      new StickyTabs(i)
    })
    // new LogoShrinked(document.querySelector('.header__logos'));

    document.querySelectorAll('.s-overlap-strips').forEach((i) => {
      new OverlapStrips(i)
    })

    document.querySelectorAll('.b-disclaimer').forEach((i) => {
      new ReadMore(i)
    })

    document.querySelectorAll('.s-tabs-table').forEach((i) => {
      new Tabs(i)
    })

    document.querySelectorAll('.b-info-tabs').forEach((i) => {
      new InfoTabs(i)
    })

    document.querySelectorAll('.b-icon-tabs').forEach((i) => {
      new InfoTabs(i)
    })

    document.querySelectorAll('.b-lottie').forEach((i) => {
      new Lottie(i)
    })

    document.querySelectorAll('.s-tabs-table__mob').forEach((i) => {
      new TableSlider(i)
    })

    document.querySelectorAll('.b-accordion').forEach((i) => {
      new Faqs(i)
    })

    document.querySelectorAll('.s-download-doc').forEach((i) => {
      new ShowMore(i)
    })

    document.querySelectorAll('.s-gallery').forEach((i) => {
      new Gallery(i)
    })

    // document.querySelectorAll('.b-net-price-table').forEach((i) => {
    //   new CollapseTable(i)
    // })

    document.querySelectorAll('.b-video').forEach((i) => {
      new Video(i)
    })

    if (document.querySelectorAll('.b-video').length) {
      // 2. This code loads the IFrame Player API code asynchronously.
      const tag = document.createElement('script')

      tag.src = 'https://www.youtube.com/iframe_api'
      const firstScriptTag = document.getElementsByTagName('script')[0]
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
    }

    document.querySelectorAll('.s-net-price__slider').forEach((i) => {
      new NetPriceSlider(i)
    })

    document.querySelectorAll('.s-map').forEach((i) => {
      new Map(i)
    })

    document.querySelectorAll('.s-steps__boxes__body').forEach((i) => {
      new StepSlider(i)
    })

    document.querySelectorAll('.s-photo-text-slider__item').forEach((i) => {
      new PhotoTextSlider(i)
    })
  }
}
